<template lang="html">
  <div>
    <v-container
      v-if="loading"
      style="height: 150px;"
    >
      <v-row
        class="fill-height"
        align="center" 
        justify="center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-row>     
    </v-container>
    <v-form 
      v-else
      ref="form" 
      v-model="formValid"
    >
      <v-container>
        <v-row>
          <v-col 
            cols="12" 
          >
            <v-autocomplete
              v-model="newSuperior"
              :items="filteredSuperior"
              :rules="rules"
              item-text="person.name"
              item-value="employee_uid"
              label="New Superior"
            />
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer />
          <v-btn
            :loading="progressing"
            color="success"
            @click="assignSuperior"
          >
            Assign Superior
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  export default {
    props: {
      employeeId: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      loading: false,
      progressing: false,
      employees: [],
      newSuperior: null,
      rules: [
        value => !!value || 'Required.',
      ],
      formValid: true,
    }),
    computed: {
      filteredSuperior () {
        return this.employees.filter(employee => {
          return employee.employee_uid !== this.employeeId
        })
      },
    },
    mounted () {
      this.loading = true

      return this.$api.employees().list()
        .then((res) => {
          this.employees = res.data
          this.loading = false
        })
    },
    methods: {
      setProgressing (status) {
        this.progressing = status
      },
      assignSuperior () {
        if (this.$refs.form.validate()) {
          this.setProgressing(true)
        
          this.$http.post('/api/employees/' + this.employeeId + '/report-to', {
            'assigned_to': this.newSuperior,
          })
            .then((res) => {
              if (res.status === 201) {
                this.$emit('edited')
              } 
            })
            .catch(() => {})
            .then(() => {
              this.setProgressing(false)
            })
        }
      },
    },

  }
</script>
